import { AnimationBuilder } from '@angular/animations';
import { Component } from '@angular/core';
import { IToolPanelAngularComp } from 'ag-grid-angular';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-community';
import { confirm } from 'devextreme/ui/dialog';
import { ToastrService } from 'ngx-toastr';
import { HelperService } from 'src/app/shared/services/helper.service';

@Component({
	selector: 'app-core-filter-builder-tool-panel',
	templateUrl: './core-filter-builder-tool-panel.component.html',
	styleUrls: ['./core-filter-builder-tool-panel.component.scss']
})
export class CoreFilterBuilderToolPanelComponent implements IToolPanelAngularComp {
	gridApi: GridApi;
	columnApi: ColumnApi;
	filterBuilderValueChanged: (value, fromLayoutChange) => any;
	datasourceId: number;
	functionId: number;
	isProcessedOutput: boolean;
	masterMapping: any = {};
	columnGroupMapping: any = {};
	filterBuilderValue: any[] = [];
	filterBuilderFields: any[];
	popupVisible: boolean = false;
	placeholderFieldCaption: string = 'Select a field...';

	customOperations: any[] = [];

	constructor(private helperService: HelperService,
		private toast: ToastrService) {}

	async agInit(params): Promise<void> {
		this.gridApi = params.api;
		this.columnApi = params.columnApi;
		this.filterBuilderValueChanged = params.filterBuilderValueChanged;
		this.datasourceId = params.datasourceId;
		this.functionId = params.functionId;
		this.isProcessedOutput = params.isProcessedOutput;
		
		this.customOperations = this.helperService.customFilterBuilderOperations;
	}

	createFields(): void {
		const columnDefs = this.gridApi.getColumnDefs();
		this.filterBuilderFields = [];
		columnDefs.forEach(colDef => {
			const colId = colDef['colId'];
			if (colId && colId !== '0' && !colId.startsWith('ag-Grid-AutoColumn-')) {
				const dataType = this.getDataType(colDef);
				this.filterBuilderFields.push(this.helperService.createFilterBuilderField(colDef.headerName, this.columnGroupMapping[colId], dataType, this.getLookupObject(colDef)));
			}
		});

		// Sort the fields alphabetically
		this.filterBuilderFields = this.filterBuilderFields.sort((a, b) => a.caption.localeCompare(b.caption));

		// Add placeholder field - if we don't add placeholder, first field is selected by default
		this.filterBuilderFields.unshift({
			caption: this.placeholderFieldCaption,
			dataField: 'PLACEHOLDER'
		});
	}

	getDataType(colDef: ColDef): string {
		let dataType = 'string';

		if (colDef.type.includes('qtyField')) {
			dataType = 'number';
		} else if (colDef.type.includes('dateField')) {
			dataType = 'date';
		} else if (colDef.type.includes('checkbox')) {
			dataType = 'boolean';
		}

		return dataType;
	}

	isLookupField(colDef: ColDef): boolean {
		return (colDef.type.includes('sellerLookup') || colDef.type.includes('sellerImportLookup') || colDef.type.includes('ruleLookup')
			|| colDef.type.includes('tagLookup') || colDef.type.includes('datasourceLookup') || colDef.type.includes('datasourceMappingLookup')
			|| colDef.type.includes('seriesLookup') || colDef.type.includes('periodLookup') || colDef.type.includes('productGroupLookup')
			|| colDef.type.includes('productLookup') || colDef.type.includes('customerGroupLookup') || colDef.type.includes('customerLookup'));
	}

	getLookupObject(colDef: ColDef): any {
		// Get mapping
		let mapping = [];
		if (colDef.type.includes('sellerLookup')) {
			mapping = this.masterMapping['seller'];
		} else if (colDef.type.includes('sellerImportLookup')) {
			mapping = this.masterMapping['sellerImport'];
		} else if (colDef.type.includes('ruleLookup')) {
			mapping = this.masterMapping['rule'];
		} else if (colDef.type.includes('tagLookup')) {
			mapping = this.masterMapping[colDef.field];
		} else if (colDef.type.includes('datasourceLookup')) {
			mapping = this.masterMapping['datasource'];
		} else if (colDef.type.includes('datasourceMappingLookup')) {
			mapping = this.masterMapping['datasourceMapping'];
		} else if (colDef.type.includes('seriesLookup')) {
			mapping = this.masterMapping['series'];
		} else if (colDef.type.includes('periodLookup')) {
			mapping = this.masterMapping['period'];
		} else if (colDef.type.includes('productGroupLookup')) {
			mapping = this.masterMapping['productGroup'];
		} else if (colDef.type.includes('productLookup')) {
			mapping = this.masterMapping['product'];
		} else if (colDef.type.includes('customerGroupLookup')) {
			mapping = this.masterMapping['customerGroup'];
		} else if (colDef.type.includes('customerLookup')) {
			mapping = this.masterMapping['customer'];
		} else {
			// If not a lookup field, set the 'lookup' property as undefined
			return undefined;
		}
		
		return this.helperService.getFilterBuilderLookupObject(mapping);
	}

	onValueChanged(): void {
		this.filterBuilderValueChanged(this.filterBuilderValue, false);
	}

	closePopup(): void {
		this.popupVisible = false;
	}

	onContentReady(e: any): void {
		this.helperService.onFilterBuilderContentReady(e, this.placeholderFieldCaption);
	}

	openFilterBuilderPopup(): void {
		this.popupVisible = true;
	}
}
